var _style, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeveloper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 414.7 376",
    style: {
      enableBackground: "new 0 0 414.7 376"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EBEBEB;}\n\t.st1{fill:#F0F0F0;}\n\t.st2{fill:#F5F5F5;}\n\t.st3{fill:#E6E6E6;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#E0E0E0;}\n\t.st6{fill:#FAFAFA;}\n\t.st7{display:none;}\n\t.st8{display:inline;}\n\t.st9{fill:#407BFF;}\n\t.st10{opacity:0.9;fill:#FFFFFF;}\n\t.st11{opacity:0.3;fill:#FFFFFF;}\n\t.st12{fill:#263238;}\n\t.st13{opacity:0.4;fill:#407BFF;}\n\t.st14{opacity:0.1;fill:#407BFF;}\n\t.st15{opacity:0.4;fill:#FFFFFF;}\n\t.st16{opacity:0.3;}\n\t.st17{opacity:0.6;fill:#407BFF;}\n\t.st18{fill:#FF5652;}\n\t.st19{fill:#FF8B7B;}\n\t.st20{opacity:0.2;}\n\t.st21{fill:#6C63FF;}\n\t.st22{opacity:0.5;fill:#FFFFFF;}\n\t.st23{opacity:0.7;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -43.7,
    y: 323.4,
    className: "st0",
    width: 500,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 130.8,
    y: 332.9,
    className: "st0",
    width: 26,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.8,
    y: 330.2,
    className: "st0",
    width: 54.1,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.5,
    y: 342.2,
    className: "st0",
    width: 26.3,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.6,
    y: 340.5,
    className: "st0",
    width: 38.8,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 340.5,
    className: "st0",
    width: 10.7,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.7,
    y: 336.3,
    className: "st0",
    width: 54.6,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 337.4,
    y: 189.1,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 720.4377 503.5772)",
    className: "st1",
    width: 45.7,
    height: 125.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 314.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 512.3514 637.9232)",
    className: "st1",
    width: 236.2,
    height: 8.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.3,
    y: 189.1,
    className: "st2",
    width: 208.1,
    height: 125.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.3,
    y: 197.5,
    className: "st1",
    width: 208.9,
    height: 45.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.3,
    y: 251.8,
    className: "st1",
    width: 208.9,
    height: 45.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.4,
    y: 197.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 682.6835 441.0173)",
    className: "st3",
    width: 7.9,
    height: 45.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.4,
    y: 251.8,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 682.6835 549.6205)",
    className: "st3",
    width: 7.9,
    height: 45.9
  })), /*#__PURE__*/React.createElement("rect", {
    x: 123.2,
    y: 181.3,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 460.6165 370.3842)",
    className: "st1",
    width: 214.2,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.4,
    y: 181.3,
    className: "st3",
    width: 52,
    height: 7.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 284.5,
    y: 22.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 676.3846 180.4117)",
    className: "st1",
    width: 107.4,
    height: 135
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.8,
    y: 22.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 648.5522 180.4117)",
    className: "st2",
    width: 127,
    height: 135
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.4,
    y: 37.3,
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 234.0703 414.4819)",
    className: "st4",
    width: 113.8,
    height: 105.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M336,102.5l20.2-9.4v-5.9L336,77.9v7.1l12.3,5.3L336,95.5V102.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M322.8,75.1h-3.7l6.5,30.1h3.7L322.8,75.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M312.6,95.5l-12.3-5.3l12.3-5.3v-7.1l-20.2,9.4v5.9l20.2,9.4V95.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 94.2,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 154.1369 417.6206)",
    className: "st1",
    width: 7,
    height: 229.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.1,321.8l-0.2-1c0.1,0,1.9-0.4,3.3-2.9c1.8-3.2,2.9-10.1-2.1-24.6c-7.8-22.3-3.2-40.3,6.2-76.2 c1.6-6.2,3.5-13.3,5.4-21c7.2-28.7,0.5-46.4-4.8-60.7c-4.1-11.1-7.4-19.9-3.2-30l0.9,0.4c-4,9.8-0.8,18.4,3.2,29.3 c5.4,14.4,12.1,32.4,4.8,61.3c-1.9,7.7-3.8,14.7-5.4,21c-9.3,35.7-13.9,53.6-6.2,75.6c5.2,14.9,4,22.1,2,25.5 C74.4,321.3,72.2,321.8,72.1,321.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "64.3,323.4 89.8,323.4 82.7,319.2 71.4,319.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "26.6,123.4 127.5,123.4 116.4,38.7 37.7,38.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "176.2,137.4 230.1,137.4 223,181.3 183.3,181.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M197.8,151.7c14.7-5.3,25.9-13.3,13.3-29.4c-12.6-16.1-32.1-16.1-45.2-8.9c-16.7,9.1-13.4,35.5-13.4,35.5 S183.2,157,197.8,151.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M212.1,137c-11.2-7.6-19.2-16.5-6.2-25.8c13-9.3,29.1-4.6,38.8,4.1c12.3,11.1,5.2,30.5,5.2,30.5 S223.3,144.6,212.1,137z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.3,117.6c13.1-0.8,24.2-4.2,17.9-18.5c-6.2-14.2-22-18.2-34.3-15.8c-15.7,3.1-19.4,22.8-19.4,22.8 S179.2,118.4,192.3,117.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8,109.2c-10.9-3.5-19.5-8.8-11.2-19.5c8.3-10.7,22.5-10.6,32.4-5.9c12.6,6,11.5,23.5,11.5,23.5 S219.8,112.7,208.8,109.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M188.3,91c10.9,3.6,20.9,4.4,20.5-9.2c-0.4-13.5-11.9-21.8-22.7-23.9C172.4,55.4,163,70.1,163,70.1 S177.4,87.4,188.3,91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216,85.2c-7.8,0.5-14.6-0.6-12-9.5c2.6-8.9,11.6-12.4,19-11.9c9.5,0.6,13.2,11.9,13.2,11.9 S223.8,84.6,216,85.2z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M239.2,237.6c-42.3,0.6-104.8,32.9-130.8-7.7c-21.8-34.1,3.4-67.5-37-92.6C42.1,118.9-5.7,86.7,38.7,53.4 C73.3,27.3,127.5,20.1,169.5,26c33,4.7,101.5,24.3,109.8,58.9c9.3,38.9-51.1,71,13.5,85.6c38.9,8.8,85.7,31.4,58.3,77.9 c-10.8,18.4-26.3,15.2-42.7,7.9C284.3,245.7,268.3,237.2,239.2,237.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M239.2,237.6c-42.3,0.6-104.8,32.9-130.8-7.7c-21.8-34.1,3.4-67.5-37-92.6C42.1,118.9-5.7,86.7,38.7,53.4 C73.3,27.3,127.5,20.1,169.5,26c33,4.7,101.5,24.3,109.8,58.9c9.3,38.9-51.1,71,13.5,85.6c38.9,8.8,85.7,31.4,58.3,77.9 c-10.8,18.4-26.3,15.2-42.7,7.9C284.3,245.7,268.3,237.2,239.2,237.6z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__327_",
    className: "st2",
    cx: 206.3,
    cy: 357.2,
    rx: 193.9,
    ry: 11.3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Desk"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 35.8,
    y: 192.1,
    className: "st9",
    width: 339.8,
    height: 12.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.8,
    y: 192.1,
    className: "st11",
    width: 90.9,
    height: 12.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "128.2,204.3 120.3,204.3 124.5,357.1 128.2,357.1 132,357.1 136.1,204.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "124.5,357.1 128.2,357.1 128.2,207.6 120.4,209  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "53.3,204.3 45.3,204.3 49.5,357.1 53.3,357.1 57,357.1 61.2,204.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "49.5,357.1 53.3,357.1 53.3,207.6 45.5,209  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "358.2,204.3 350.3,204.3 354.4,357.1 358.2,357.1 362,357.1 366.1,204.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "354.4,357.1 358.2,357.1 358.2,207.6 350.4,209  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "283.2,204.3 275.3,204.3 279.4,357.1 283.2,357.1 287,357.1 291.1,204.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "279.4,357.1 283.2,357.1 283.2,207.6 275.4,209  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M197.1,126.8h-80.8c-2.9,0-4.8,2.4-4.2,5.3l10.8,51.3c0.6,2.9,3.5,5.3,6.4,5.3h80.8c2.9,0,4.8-2.4,4.2-5.3 l-10.8-51.3C202.9,129.2,200,126.8,197.1,126.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M130,185.8c-1.9,0-3.9-1.7-4.3-3.6l-10.8-51.4c-0.2-0.8,0-1.5,0.4-2c0.4-0.5,1-0.7,1.7-0.7h80.8 c1.9,0,3.9,1.7,4.3,3.6l10.8,51.3c0.2,0.8,0,1.5-0.4,2c-0.4,0.5-1,0.7-1.7,0.7H130z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M191,181.7L180.8,133c-0.3-1.2,0.7-2.4,1.9-2.4h13.1c0.9,0,1.7,0.7,1.9,1.6l10.2,48.7 c0.3,1.2-0.7,2.4-1.9,2.4h-13.1C192,183.3,191.2,182.6,191,181.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "121.7,134.9 121.2,132.8 137.4,132.8 137.9,134.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "129.1,140.1 128.7,138 157.1,138 157.5,140.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "130.6,145.3 130.2,143.2 162,143.2 162.5,145.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "132.1,150.6 131.7,148.5 157.3,148.5 157.8,150.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "126.6,159.1 126.1,157 136.4,157 136.8,159.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "134.1,164.3 133.6,162.2 146.1,162.2 146.5,164.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "149.5,164.3 149.1,162.2 161.6,162.2 162,164.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "135.6,169.5 135.1,167.4 177.3,167.4 177.8,169.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "137,174.8 136.6,172.7 168.8,172.7 169.2,174.8  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M234.9,188.4H128.5c-2.9,0-4.8,1.6-4.2,3.7h116.9C240.6,190.1,237.8,188.4,234.9,188.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M93.5,113.8L83.3,65.2c-0.3-1.2,0.7-2.4,1.9-2.4h82.6c0.9,0,1.7,0.7,1.9,1.6L180,113 c0.3,1.2-0.7,2.4-1.9,2.4H95.5C94.5,115.4,93.7,114.8,93.5,113.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "122.9,64.4 105.6,64.4 105.2,62.5 122.5,62.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "120.1,67.4 113.1,67.4 112.7,65.5 119.7,65.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "131.7,67.4 120.9,67.4 120.6,65.5 131.3,65.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "136.3,70.4 113.7,70.4 113.4,68.5 135.9,68.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "133.5,73.3 114.4,73.3 114,71.5 133.1,71.5  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "146.1,104.9 134,104.9 134.4,106.8 146.5,106.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "131,100.9 113.2,100.9 112.8,99 130.6,99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "138.1,107.9 121.6,107.9 122,109.8 138.5,109.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "133.1,104.9 121,104.9 121.3,106.8 133.5,106.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "144.6,102 120.3,102 120.7,103.8 145,103.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "122.3,50.5 102.7,50.5 102.3,48.7 121.9,48.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "132,57.6 110.3,57.6 110.7,59.5 132.4,59.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "127.7,54.6 109.7,54.6 110.1,56.5 128,56.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "128.8,51.6 109.1,51.6 109.5,53.5 129.2,53.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "122.1,78.2 108.4,78.2 108,76.3 121.7,76.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "143.5,85.2 116.8,85.2 117.2,87.1 143.9,87.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "127.3,82.3 116.2,82.3 116.6,84.1 127.7,84.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "139.2,82.3 128.2,82.3 128.6,84.1 139.6,84.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "139.9,79.3 115.6,79.3 116,81.1 140.3,81.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "139.9,94.2 118.7,94.2 119.1,96 140.3,96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "124.2,91.2 118.1,91.2 118.5,93 124.6,93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "133.9,91.2 125.1,91.2 125.5,93 134.3,93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "141.8,88.2 117.5,88.2 117.9,90.1 142.2,90.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "160.9,87.7 152.2,87.7 151.8,85.8 160.5,85.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "175.4,87.7 162,87.7 161.6,85.8 175,85.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "181.1,90.7 152.8,90.7 152.5,88.8 180.7,88.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "177.4,93.7 153.5,93.7 153.1,91.8 177,91.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "188.1,75.9 161,75.9 161.4,77.7 188.5,77.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "182.8,72.9 160.4,72.9 160.8,74.8 183.2,74.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "178.8,69.9 154,69.9 154.4,71.8 179.1,71.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "189.3,105.6 155.9,105.6 156.3,107.4 189.7,107.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "169.1,102.6 155.3,102.6 155.7,104.5 169.5,104.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "184.1,102.6 170.3,102.6 170.7,104.5 184.5,104.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "185.1,99.6 154.7,99.6 155.1,101.5 185.5,101.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "184.3,114.5 157.8,114.5 158.2,116.3 184.7,116.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "164.9,111.5 157.2,111.5 157.6,113.4 165.3,113.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "177,111.5 166,111.5 166.3,113.4 177.3,113.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "187,108.5 156.6,108.5 157,110.4 187.4,110.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "105.9,116.8 85.2,116.8 85.6,118.7 106.3,118.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "99.8,113.8 84.6,113.8 85,115.7 100.2,115.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "116.1,113.8 100.9,113.8 101.3,115.7 116.5,115.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "114.4,110.8 84,110.8 84.3,112.7 114.8,112.7  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "347.3,172.7 334.4,172.7 335.9,192.1 345.8,192.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "347.3,172.7 334.4,172.7 335.9,192.1 345.8,192.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "67.5,159.2 85.9,159.2 79.6,192.1 61.2,192.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "91,150.4 64.9,150.4 72.2,192.1 98.3,192.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "63.4,150.4 64.9,150.4 72.2,192.1 70.7,192.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "63.4,150.4 64.9,150.4 72.2,192.1 70.7,192.1  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "75.9,187.6 70.2,154.8 87.2,154.8 93,187.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "92.2,187.6 86.4,154.8 87.2,154.8 93,187.6  "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Character_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M220.1,97c0.4,0.8,0.2,1.6-0.3,1.9c-0.5,0.2-1.2-0.2-1.6-1c-0.4-0.8-0.2-1.6,0.3-1.9 C219,95.7,219.7,96.2,220.1,97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M220.4,98.6c0,0,0.3,5.5-0.7,8.6c2,0.7,4.2-1.1,4.2-1.1L220.4,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M220.2,90.4c-0.1,0.1-0.2,0.1-0.3,0.1c-2.3,0.1-3.3,1.7-3.3,1.8c-0.1,0.2-0.5,0.3-0.7,0.2 c-0.2-0.1-0.3-0.5-0.2-0.7c0.1-0.1,1.3-2.1,4.1-2.3c0.3,0,0.5,0.2,0.5,0.5C220.4,90.1,220.3,90.3,220.2,90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M249.6,95.8c3.1,10.7,6.5,19,10.8,23.7c0,0,0.1,8.4-14.3,12.4c-15.8,4.4-9.7-5.7-9.7-5.7 c8-4.5,7.2-11.2,1.2-13.7L249.6,95.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M263.6,117.5c-0.3-3.9-0.6-8.4-3.1-8.5c-2.7-0.1-18.1,6.8-21.3,11.6c-3.3,4.9,3.1,9.6,3.1,9.6L263.6,117.5z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M232.1,178l-13.3-0.4l0.2,11.1c0,0,11.6-1.2,12.1-4.2L232.1,178z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "211.8,183 210.4,188.7 219.1,188.7 218.8,177.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M285.5,131.7l-0.3,2.9c-0.1,0.9-0.2,1.8-0.3,2.7c-0.2,1.8-0.5,3.6-0.8,5.4c-0.6,3.6-1.4,7.2-2.3,10.8 c-0.9,3.6-2,7.2-3.3,10.9c-0.7,1.8-1.4,3.7-2.3,5.5c-0.9,1.9-1.8,3.7-3,5.6c-0.3,0.5-0.6,1-0.9,1.4c-0.3,0.5-0.7,1-1,1.5 c-0.4,0.5-0.7,1-1.2,1.5l-0.7,0.7c-0.2,0.2-0.4,0.5-0.7,0.8c-2.3,2.3-4.7,3.7-6.9,4.7c-4.5,2-8.5,2.7-12.4,3.1 c-2,0.2-3.9,0.3-5.8,0.4c-1.9,0.1-3.8,0-5.6-0.1c-1.9-0.1-3.7-0.3-5.5-0.5c-1.9-0.2-3.6-0.5-5.6-0.9l0.3-10.4 c6.4-1.3,13.1-2.6,18.9-4.5c1.4-0.5,2.8-1,4.1-1.6c1.2-0.5,2.4-1.1,3.2-1.7c0.8-0.6,1.4-1.2,1.5-1.4l0.3-0.5 c0.1-0.1,0.2-0.4,0.4-0.6c0.1-0.2,0.3-0.5,0.4-0.7c0.1-0.3,0.3-0.5,0.4-0.8c1-2.2,2.1-5,2.9-7.9c0.8-2.9,1.6-6,2.2-9.2 c0.7-3.1,1.2-6.4,1.8-9.6l0.8-4.9l0.7-4.7L285.5,131.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M285.5,131.7l-0.3,2.9c-0.1,0.9-0.2,1.8-0.3,2.7c-0.2,1.8-0.5,3.6-0.8,5.4c-0.6,3.6-1.4,7.2-2.3,10.8 c-0.9,3.6-2,7.2-3.3,10.9c-0.7,1.8-1.4,3.7-2.3,5.5c-0.9,1.9-1.8,3.7-3,5.6c-0.3,0.5-0.6,1-0.9,1.4c-0.3,0.5-0.7,1-1,1.5 c-0.4,0.5-0.7,1-1.2,1.5l-0.7,0.7c-0.2,0.2-0.4,0.5-0.7,0.8c-2.3,2.3-4.7,3.7-6.9,4.7c-4.5,2-8.5,2.7-12.4,3.1 c-2,0.2-3.9,0.3-5.8,0.4c-1.9,0.1-3.8,0-5.6-0.1c-1.9-0.1-3.7-0.3-5.5-0.5c-1.9-0.2-3.6-0.5-5.6-0.9l0.3-10.4 c6.4-1.3,13.1-2.6,18.9-4.5c1.4-0.5,2.8-1,4.1-1.6c1.2-0.5,2.4-1.1,3.2-1.7c0.8-0.6,1.4-1.2,1.5-1.4l0.3-0.5 c0.1-0.1,0.2-0.4,0.4-0.6c0.1-0.2,0.3-0.5,0.4-0.7c0.1-0.3,0.3-0.5,0.4-0.8c1-2.2,2.1-5,2.9-7.9c0.8-2.9,1.6-6,2.2-9.2 c0.7-3.1,1.2-6.4,1.8-9.6l0.8-4.9l0.7-4.7L285.5,131.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M226.5,145c3.2,13.4,7.4,35.8,8.3,65.1h58.6c0.3-7.2-0.9-48-6.8-77.5c-2.2-11.2-13.2-18.5-24.4-16 c-0.1,0-0.2,0-0.3,0.1c-7.3,1.7-17.8,4.3-24,6.7c-0.1,0-0.2,0.1-0.3,0.1C229.1,126.8,224.3,136,226.5,145z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M230.3,163.7c0.5,2.8,0.9,5.8,1.4,8.9c4.8-5,6.3-20.3,6.3-20.3L230.3,163.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M181.6,178.7l-13.2-1.2l-0.4,11.1c0,0,6.8,2.2,12.3-3.5L181.6,178.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "162,180.8 157.8,188.4 167.9,188.6 168.4,177.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M248.4,139.9c-0.9,1.8-1.7,3.3-2.7,4.9c-0.9,1.6-1.8,3.2-2.8,4.7c-1.9,3.1-3.8,6.2-5.9,9.2 c-4.1,6.1-8.5,12-13.7,17.6c-2.6,2.9-5.4,5.6-8.7,8.3c-0.4,0.3-0.9,0.7-1.3,1c-0.4,0.3-0.8,0.6-1.5,1c-0.6,0.4-1.2,0.7-1.8,1.1 c-0.6,0.3-1.2,0.6-1.8,0.9c-2.4,1-4.7,1.7-6.9,2.1c-4.4,0.8-8.6,0.7-12.5,0.3c-2-0.3-3.9-0.6-5.8-1c-0.9-0.2-1.9-0.5-2.8-0.8 c-1-0.3-1.8-0.6-2.9-1l1.7-10.3c6.3-0.9,13.1-1.9,17.7-4.1c1.2-0.5,2.2-1.1,2.9-1.7c0.4-0.3,0.7-0.6,0.9-0.8 c0.1-0.1,0.4-0.4,0.6-0.6c0.2-0.2,0.5-0.4,0.7-0.7c2-1.9,4-4.3,6-6.7c3.9-5,7.7-10.5,11.3-16.2c1.8-2.8,3.6-5.7,5.3-8.6l2.6-4.3 l2.5-4.3L248.4,139.9z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "232.4,348.6 221.4,348.6 215.9,323.3 226.9,323.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M220.8,346.3h12.3c0.4,0,0.8,0.3,0.9,0.7l2.2,9.7c0.2,1-0.6,2-1.6,1.9c-4.3-0.1-6.4-0.3-11.8-0.3 c-3.3,0-7.6,0.3-12.2,0.3c-4.5,0-5.2-4.5-3.3-5c8.4-1.8,9-4.4,11.7-6.8C219.5,346.5,220.1,346.3,220.8,346.3z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "226.9,323.3 215.9,323.3 219,337.3 229.7,336.3  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M246,82.9c3.9,10.1,6.8,15.8,4.1,23.2c-4,11.1-18.2,12.2-25.1,3.4c-6.2-7.9-11.6-23.1-3.8-31.5 C229,69.8,242.1,72.8,246,82.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M226.8,98.1c-1.6,2.2-2.9,3.9-2.9,3.9s-3.4-8.4-2.1-12.2c-1.6-3.3-5,1.5-6.2-4.8 c-1.2-6.3,4.2-13.1,6.2-14.5c0.3,0.5,0.3,2.3,0.3,2.3s8.1-7.2,19.6-6.2c-0.8,0.8-1.1,2.9-1.1,2.9s11.9,2,14.6,8.7 c-1.7-0.8-3-1.1-3-1.1s3.4,4.2,2.4,10.7c-1,6.5-1.5,13.7-1.3,16.5c0.1,2.8-7.7,8.3-12.4,2.5C236.1,101,226.8,98.1,226.8,98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M231.8,95.9c0.7,2.5,0.3,5.1-0.5,7.1c-1.3,2.9-3.9,2.3-5.2-0.3c-1.2-2.4-1.9-6.7,0.2-8.8 C228.3,91.8,231,93,231.8,95.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M252.3,210.1c0,0-50.8,18.4-52.3,42.8c-2.8,44.9,15.6,80.5,15.6,80.5l16.8-1.8c0,0-3-14.5-5.2-55.2 c-2.8-51.1,84,1.2,66.1-66.4L252.3,210.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M252.3,210.1c0,0-50.8,18.4-52.3,42.8c-2.8,44.9,15.6,80.5,15.6,80.5l16.8-1.8c0,0-3-14.5-5.2-55.2 c-2.8-51.1,84,1.2,66.1-66.4L252.3,210.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M211,327.2c-0.1,0,2.7,7.5,2.7,7.5l21-2.1l-1.1-6.8L211,327.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "185.1,349.8 174.1,349.8 170.9,324.5 181.9,324.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M174,346.3l12,0c0.4,0,0.8,0.3,0.9,0.7l2.2,9.7c0.2,1-0.5,2-1.6,1.9c-4.3-0.1-10.5-0.3-16-0.3 c-6.3,0-7.6,0.4-15,0.4c-4.5,0-5.7-4.5-3.9-4.9c8.6-1.9,11.3-2.1,18.7-6.7C172.2,346.6,173.1,346.3,174,346.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "170.9,324.5 172.7,338.3 183.5,337.6 181.9,324.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M234.8,210.1c0,0-83.3,7.4-82.4,49.2c0.9,43.5,17.2,72.9,17.2,72.9h16.3c0,0-3.1-22.6-2.5-65.4 c0.2-12.8,26.1-17.1,51.4-18.6c21.9-1.3,42.4-13.8,50.9-34l1.7-4.1H234.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M234.8,210.1c0,0-83.3,7.4-82.4,49.2c0.9,43.5,17.2,72.9,17.2,72.9h16.3c0,0-3.1-22.6-2.5-65.4 c0.2-12.8,26.1-17.1,51.4-18.6c21.9-1.3,42.4-13.8,50.9-34l1.7-4.1H234.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M165.8,327.8c-0.1,0,2.8,7.5,2.8,7.5l19.6-1.4l-1.1-6.8L165.8,327.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M256.6,163.1l-10.6,40.7c-2.7,10.4-4.1,21.1-4.1,31.9v18.9c0,4.8,3.5,8.7,7.9,8.7h54.2 c4.3,0,7.9-3.9,7.9-8.7v-18.9c0-10.8,1.4-21.6,4.1-31.9l9.3-36c1.4-5.5-2.3-11-7.6-11h-53.6 C260.7,156.8,257.6,159.4,256.6,163.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M189.3,243.6l1.8,10.1c0.9,5.3,5.6,9.6,10.4,9.6h60.2c4.8,0,8-4.3,7.1-9.6l-1.8-10.1 c-1.1-6-6.4-10.9-11.9-10.9h-57.8C191.8,232.7,188.2,237.6,189.3,243.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "267.5,273.5 236,273.5 232.9,263.3 270.6,263.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 246.1,
    y: 273.5,
    className: "st9",
    width: 11.3,
    height: 75.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "257.4,348.9 246.1,348.9 246.1,275.3 257.4,276.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "254.6,348.9 251.9,348.9 251.9,275.9 254.6,276.2  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M277.6,360.6h-51.8c-1.4,0-2-1.8-0.8-2.6l8.2-6c3.9-2.9,8.7-4.5,13.6-4.5h9.8c4.9,0,9.7,1.6,13.6,4.5l8.2,6 C279.6,358.8,279,360.6,277.6,360.6z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloper);
export default __webpack_public_path__ + "static/media/developer.ef097afbc427c634086d2f1c2ad6032e.svg";
export { ForwardRef as ReactComponent };